import { Component } from '@angular/core';

@Component({
  selector: 'loyale-reload-cache',
  templateUrl: './reload-cache.component.html',
  standalone: false
})
export class ReloadCacheComponent { }
